import { render, staticRenderFns } from "./appealDlog.vue?vue&type=template&id=efffbe06&scoped=true&"
import script from "./appealDlog.vue?vue&type=script&lang=js&"
export * from "./appealDlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efffbe06",
  null
  
)

export default component.exports